import { type Logos, logos } from '~/routes/$/constants/logos';

type LogoImageProps = {
  altText?: string;
  logoName: Logos;
  resourcesUrl: string;
};

const logoImgProps: { [K in Logos]?: React.ImgHTMLAttributes<HTMLImageElement> } = {
  ODDSCHECKER: { width: 213, height: 34 },
};

const getLogoImgProps = (logoName: Logos): React.ImgHTMLAttributes<HTMLImageElement> => logoImgProps[logoName] ?? {};

export const LogoImage = ({ altText = 'OddsChecker', logoName, resourcesUrl }: LogoImageProps) => (
  <img
    alt={altText}
    src={`${resourcesUrl}/assets/img/${logos[logoName] ?? logos.ODDSCHECKER}`}
    {...getLogoImgProps(logoName)}
  />
);
